'use strict';

(function(){
    try {
        new Blob();
        return;
    } catch (e) {
    }
    // fake Blob
    // new Blob([excelData], { type: 'application/vnd.ms-excel' })
    function FakeBlob(data, option) {
        this.data = data;
        this.option = option;
    }
    FakeBlob.prototype.fakeBlob = true;
    window.Blob = FakeBlob;
})();


var util = angular.module('gymsystem.util');

util.factory('serverDownloader', ['$q', '$http', function($q, $http) {
    var self = {};

    var isSafari = !!window.Blob.prototype.fakeBlob;
    if(!isSafari) {
        var ua = navigator.userAgent.toLowerCase(); 
        if (ua.indexOf('safari') != -1) { 
            isSafari = ua.indexOf('chrome') < 0;
        }
    }
    self.isSafari = function() {
        return isSafari;
    };

    function arrayBufferToBase64( buffer ) {
        var binary = '';
        var bytes = new Uint8Array( buffer );
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode( bytes[ i ] );
        }
        return window.btoa( binary );
    }


    self.download = function(input) {
        var fd, contentType;
        if(input.blob.fakeBlob) {
            contentType = input.blob.option.type;
            fd = new FormData();
            fd.append('file', arrayBufferToBase64(input.blob.data[0]));
            fd.append('filetype', 'base64');
        } else {
            contentType = input.blob.type;
            fd = new FormData();
            fd.append('file', input.blob);
            //fd.append('filename', input.filename);
        }

        $http.post('/api/utils/serverdownloader/save', fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).success(function(data) {
            document.location.href = '/api/utils/serverdownloader/load?secret=' + data.secret + '&type=' + encodeURIComponent(contentType) + '&filename=' + encodeURIComponent(input.filename);
        }).error(function () {
            console.warn('Sent error');
        });

    };

    return self;
}]);
